import { ChangeEvent, memo, useRef } from 'react';
import styled from 'styled-components';
import { GoFileDirectoryFill } from 'react-icons/go';
import { FaPlus } from 'react-icons/fa6';

import theme from '@styles/theme';

import { FlexBox } from './StyledComponents';

type StyledFileUploadProps = {
    width?: number;
    margin?: string;
    name?: string;
    title?: string;
    subTitle?: string;
    file?: File | null;
    previewUrl?: string;
    multiple?: boolean;
    accept?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    description?: string;
    amountTitle?: string;
    amountCount?: string;
};

const StyledFileUpload = ({
    width,
    margin,
    name,
    title,
    subTitle,
    file,
    previewUrl,
    multiple = false,
    accept = 'image/*',
    onChange = () => null,
    placeholder = '첨부파일 첨부하기',
    description = '파일 크기는 최대 10MB까지 추가할 수 있습니다.',
    amountTitle,
    amountCount
}: StyledFileUploadProps) => {
    const fileRef = useRef<HTMLInputElement>(null);
    return (
        <Wrapper $width={width} $margin={margin}>
            <FlexBox $justifyContent="space-between">
                {title && (
                    <Text>
                        {title}
                        {subTitle && <SubText>{subTitle}</SubText>}
                    </Text>
                )}
                {amountTitle && (
                    <Text>
                        {amountTitle}
                        {amountCount && <SubText>{amountCount}</SubText>}
                    </Text>
                )}
            </FlexBox>
            <InputBox>
                <FlexBox $justifyContent="space-between">
                    <FlexBox $alignItems="flex-start" $gap={12}>
                        <GoFileDirectoryFill
                            size={24}
                            color={theme.colors.lightGrayFontColor}
                        />
                        <FlexBox
                            $flexDirection="column"
                            $alignItems="flex-start"
                        >
                            <Placeholder>{placeholder}</Placeholder>
                            <SubText>{description}</SubText>
                        </FlexBox>
                    </FlexBox>
                    <FaPlus size={16} color={theme.colors.lightGrayFontColor} />
                </FlexBox>
                <Input
                    name={name}
                    type="file"
                    ref={fileRef}
                    multiple={multiple}
                    accept={accept}
                    onChange={onChange}
                />
            </InputBox>
        </Wrapper>
    );
};

export default memo(StyledFileUpload);

const Wrapper = styled.div<{ $width?: number; $margin?: string }>`
    width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;
const Text = styled.div`
    font-size: 14px;
    display: flex;
    align-content: center;
    margin-bottom: 8px;
`;
const SubText = styled.div`
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
    margin-left: 4px;
`;
const InputBox = styled.label`
    width: 100%;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    border: ${theme.colors.ultraLightGrayBorder} 1px solid;
    border-radius: 4px;
    cursor: pointer;
`;
const Placeholder = styled.div`
    font-size: 16px;
`;
const Input = styled.input`
    display: none;
`;
